export default function OptionChoice(props) {
  return props.children;
}
